import * as types from "../actions/actionTypes";
import { USER_MANAGEMENT_GET_USER_IMPREST_PAYMENT_REQUEST } from "../actions/actionTypes";

const CONFIRM_INITIAL_STATUS = {
  show: false,
  message: "",
  acceptButton: {
    text: "",
    action: () => {}
  }
};

const initialState = {
  userListLoading: true,
  userList: {},
  userListError: "",

  checkPhoneProcessing: false,
  checkPhoneData: null,

  initLoading: false,
  initData: {},
  initError: false,

  lastSelectedTeams: null,

  userProfileLoading: false,
  userProfileData: null,
  userProfileError: "",

  projectProfileLoading: false,
  projectProfileData: null,
  projectProfileError: "",

  projectUserProfileLoading: false,
  projectUserProfileError: "",
  projectUserProfileData: null,

  processing: false,

  userAccountingCodeLoading: false,
  userAccountingCodeData: null,
  userAccountingCodeError: "",
  userAccountingCodeProcessing: false,

  userImprestPaymentLoading: false,
  userImprestPaymentData: null,
  userImprestPaymentError: "",
  userImprestPaymentProcessing: false,

  sharedProjects: [],
  sharedProjectsLoading: true,
  sharedProjectsError: "",

  menuModalStatus: false,

  confirm: CONFIRM_INITIAL_STATUS
};

const UserManagement = (state = initialState, action) => {
  switch (action.type) {
    case types.USER_MANAGEMENT_GET_USER_LIST_REQUEST:
      return {
        ...state,
        userListLoading: true,
        userListError: "",
        userList: {}
      };
    case types.USER_MANAGEMENT_GET_USER_LIST_SUCCESS:
      return { ...state, userList: action.data, userListLoading: false };
    case types.USER_MANAGEMENT_GET_USER_LIST_FAILURE:
      return {
        ...state,
        userListLoading: false,
        userListError: action.error
      };

    case types.USER_MANAGEMENT_CHECK_PHONE_NUMBER_REQUEST:
      return {
        ...state,
        checkPhoneProcessing: true,
        checkPhoneData: null
      };
    case types.USER_MANAGEMENT_CHECK_PHONE_NUMBER_SUCCESS:
      let clonedUser = { phone_number: action.invitedPhoneNumber };
      if (action.data && action.data.user) {
        clonedUser = action.data.user;
      }
      return {
        ...state,
        checkPhoneData: { ...action.data, clonedUser: clonedUser },
        checkPhoneProcessing: false
      };
    case types.USER_MANAGEMENT_CHECK_PHONE_NUMBER_FAILURE:
      return {
        ...state,
        checkPhoneProcessing: false
      };

    case types.USER_MANAGEMENT_CLEAR_FETCHED_USER_DATA:
      return {
        ...state,
        checkPhoneData: null
      };

    case types.USER_MANAGEMENT_INIT_INVITE_REQUEST:
      return {
        ...state,
        initLoading: true,
        initError: "",
        initData: {}
      };
    case types.USER_MANAGEMENT_INIT_INVITE_SUCCESS:
      return {
        ...state,
        initData: action.data,
        initLoading: false
      };
    case types.USER_MANAGEMENT_INIT_INVITE_FAILURE:
      return {
        ...state,
        initLoading: false,
        initError: action.error
      };

    case types.USER_MANAGEMENT_CLEAR_FETCHED_INIT_INVITE_DATA:
      return {
        ...state,
        initData: {}
      };

    case types.USER_MANAGEMENT_SAVE_LAST_SELECTED_TEAMS:
      return {
        ...state,
        lastSelectedTeams: action.data
      };
    case types.USER_MANAGEMENT_CLEAR_LAST_SELECTED_TEAMS:
      return {
        ...state,
        lastSelectedTeams: null
      };

    case types.USER_MANAGEMENT_SHOW_USER_PROFILE_REQUEST:
      return {
        ...state,
        userProfileLoading: true,
        userProfileError: "",
        userProfileData: null
      };
    case types.USER_MANAGEMENT_SHOW_USER_PROFILE_SUCCESS:
      return {
        ...state,
        userProfileData: action.data,
        userProfileLoading: false
      };
    case types.USER_MANAGEMENT_SHOW_USER_PROFILE_FAILURE:
      return {
        ...state,
        userProfileLoading: false,
        userProfileError: action.error
      };

    case types.USER_MANAGEMENT_SHOW_PROJECT_PROFILE_REQUEST:
      return {
        ...state,
        projectProfileLoading: true,
        projectProfileError: "",
        projectProfileData: null
      };
    case types.USER_MANAGEMENT_SHOW_PROJECT_PROFILE_SUCCESS:
      return {
        ...state,
        projectProfileData: action.data,
        projectProfileLoading: false
      };
    case types.USER_MANAGEMENT_SHOW_PROJECT_PROFILE_FAILURE:
      return {
        ...state,
        projectProfileLoading: false,
        projectProfileError: action.error
      };

    case types.USER_MANAGEMENT_SHOW_PROJECT_USER_PROFILE_REQUEST_CLONE:
      return {
        ...state,
        projectUserProfileLoading: true,
        projectUserProfileError: "",
        projectUserProfileData: null
      };

    case types.USER_MANAGEMENT_SHOW_PROJECT_USER_PROFILE_REQUEST:
      return {
        ...state,
        projectUserProfileLoading: true,
        projectUserProfileError: "",
        projectUserProfileData: null
      };
    case types.USER_MANAGEMENT_SHOW_PROJECT_USER_PROFILE_SUCCESS:
      return {
        ...state,
        projectUserProfileData: action.data,
        projectUserProfileLoading: false,
        initData: { available_teams: action.data.teams } // to use for checkProjectTeamNumbers function of change admin to manager
      };
    case types.USER_MANAGEMENT_SHOW_PROJECT_USER_PROFILE_FAILURE:
      return {
        ...state,
        projectUserProfileLoading: false,
        projectUserProfileError: action.error
      };

    case types.USER_MANAGEMENT_INVITE_REQUEST:
      return {
        ...state,
        processing: true
      };
    case types.USER_MANAGEMENT_INVITE_SUCCESS:
      return {
        ...state,
        processing: false
      };
    case types.USER_MANAGEMENT_INVITE_FAILURE:
      return {
        ...state,
        processing: false
      };

    case types.USER_MANAGEMENT_CONVERT_ADMIN_TO_MANAGER_REQUEST:
      return {
        ...state,
        processing: true
      };
    case types.USER_MANAGEMENT_CONVERT_ADMIN_TO_MANAGER_SUCCESS:
      return {
        ...state,
        processing: false
      };
    case types.USER_MANAGEMENT_CONVERT_ADMIN_TO_MANAGER_FAILURE:
      return {
        ...state,
        processing: false
      };

    case types.USER_MANAGEMENT_CONVERT_MANAGER_TO_ADMIN_REQUEST:
      return {
        ...state,
        processing: true
      };
    case types.USER_MANAGEMENT_CONVERT_MANAGER_TO_ADMIN_SUCCESS:
      return {
        ...state,
        processing: false
      };
    case types.USER_MANAGEMENT_CONVERT_MANAGER_TO_ADMIN_FAILURE:
      return {
        ...state,
        processing: false
      };

    case types.USER_MANAGEMENT_REACTIVATE_REQUEST:
      return {
        ...state,
        processing: true
      };
    case types.USER_MANAGEMENT_REACTIVATE_SUCCESS:
      return {
        ...state,
        processing: false
      };
    case types.USER_MANAGEMENT_REACTIVATE_FAILURE:
      return {
        ...state,
        processing: false
      };

    case types.USER_MANAGEMENT_DEACTIVATE_REQUEST:
      return {
        ...state,
        processing: true
      };
    case types.USER_MANAGEMENT_DEACTIVATE_SUCCESS:
      return {
        ...state,
        processing: false
      };
    case types.USER_MANAGEMENT_DEACTIVATE_FAILURE:
      return {
        ...state,
        processing: false
      };

    case types.USER_MANAGEMENT_DELETE_INVITATION_REQUEST:
      return {
        ...state,
        processing: true
      };
    case types.USER_MANAGEMENT_DELETE_INVITATION_SUCCESS:
      return {
        ...state,
        processing: false
      };
    case types.USER_MANAGEMENT_DELETE_INVITATION_FAILURE:
      return {
        ...state,
        processing: false
      };

    case types.USER_MANAGEMENT_REMOVE_MANAGER_FROM_TEAM_REQUEST:
      return {
        ...state,
        processing: true
      };
    case types.USER_MANAGEMENT_REMOVE_MANAGER_FROM_TEAM_SUCCESS:
      return {
        ...state,
        processing: false
      };
    case types.USER_MANAGEMENT_REMOVE_MANAGER_FROM_TEAM_FAILURE:
      return {
        ...state,
        processing: false
      };

    case types.USER_MANAGEMENT_INVITE_MANAGER_TO_OTHER_TEAMS_REQUEST:
      return {
        ...state,
        processing: true
      };
    case types.USER_MANAGEMENT_INVITE_MANAGER_TO_OTHER_TEAMS_SUCCESS:
      return {
        ...state,
        processing: false
      };
    case types.USER_MANAGEMENT_INVITE_MANAGER_TO_OTHER_TEAMS_FAILURE:
      return {
        ...state,
        processing: false
      };

    case types.USER_MANAGEMENT_CHANGE_TEAM_PERMISSIONS_REQUEST:
      return {
        ...state,
        processing: true
      };
    case types.USER_MANAGEMENT_CHANGE_TEAM_PERMISSIONS_SUCCESS:
      return {
        ...state,
        processing: false
      };
    case types.USER_MANAGEMENT_CHANGE_TEAM_PERMISSIONS_FAILURE:
      return {
        ...state,
        processing: false
      };

    case types.USER_MANAGEMENT_GET_USER_ACCOUNTING_CODES_REQUEST:
      return {
        ...state,
        userAccountingCodeLoading: true,
        userAccountingCodeError: "",
        userAccountingCodeData: null
      };
    case types.USER_MANAGEMENT_GET_USER_ACCOUNTING_CODES_SUCCESS:
      return {
        ...state,
        userAccountingCodeLoading: false,
        userAccountingCodeData: action.data
      };
    case types.USER_MANAGEMENT_GET_USER_ACCOUNTING_CODES_FAILURE:
      return {
        ...state,
        userAccountingCodeLoading: false,
        userAccountingCodeError: action.error
      };

    case types.USER_MANAGEMENT_EDIT_USER_ACCOUNTING_CODES_REQUEST:
      return {
        ...state,
        userAccountingCodeProcessing: true
      };
    case types.USER_MANAGEMENT_EDIT_USER_ACCOUNTING_CODES_SUCCESS:
      return {
        ...state,
        userAccountingCodeProcessing: false
      };
    case types.USER_MANAGEMENT_EDIT_USER_ACCOUNTING_CODES_FAILURE:
      return {
        ...state,
        userAccountingCodeProcessing: false
      };

    case types.USER_MANAGEMENT_EDIT_IMPREST_PAYMENT_LIMIT_REQUEST:
      return {
        ...state,
        userImprestPaymentProcessing: true
      };
    case types.USER_MANAGEMENT_EDIT_IMPREST_PAYMENT_LIMIT_SUCCESS:
      return {
        ...state,
        userImprestPaymentProcessing: false
      };
    case types.USER_MANAGEMENT_EDIT_IMPREST_PAYMENT_LIMIT_FAILURE:
      return {
        ...state,
        userImprestPaymentProcessing: false
      };

    case types.USER_MANAGEMENT_GET_USER_IMPREST_PAYMENT_REQUEST:
      return {
        ...state,
        userImprestPaymentLoading: true,
        userImprestPaymentError: "",
        userImprestPaymentData: null
      };
    case types.USER_MANAGEMENT_GET_USER_IMPREST_PAYMENT_SUCCESS:
      return {
        ...state,
        userImprestPaymentLoading: false,
        userImprestPaymentData: action.data
      };
    case types.USER_MANAGEMENT_GET_USER_IMPREST_PAYMENT_FAILURE:
      return {
        ...state,
        userImprestPaymentLoading: false,
        userImprestPaymentError: action.error
      };

    case types.USER_MANAGEMENT_GET_SHARED_PROJECTS_REQUEST:
      return {
        ...state,
        sharedProjectsLoading: true,
        sharedProjectsError: "",
        sharedProjects: []
      };
    case types.USER_MANAGEMENT_GET_SHARED_PROJECTS_SUCCESS:
      return {
        ...state,
        sharedProjects: action.data,
        sharedProjectsLoading: false
      };
    case types.USER_MANAGEMENT_GET_SHARED_PROJECTS_FAILURE:
      return {
        ...state,
        sharedProjectsLoading: false,
        sharedProjectsError: action.error
      };

    case types.USER_MANAGEMENT_SHOW_MENU_MODAL:
      return {
        ...state,
        menuModalStatus: true
      };
    case types.USER_MANAGEMENT_CLOSE_MENU_MODAL:
      return {
        ...state,
        menuModalStatus: false
      };

    case types.USER_MANAGEMENT_SET_CONFIRM_DATA:
      return {
        ...state,
        confirm: action.data
      };
    case types.USER_MANAGEMENT_CLOSE_CONFIRM:
      return {
        ...state,
        confirm: CONFIRM_INITIAL_STATUS
      };
    default:
      return state;
  }
};

export default UserManagement;
